import { ALL_LANGUAGES } from '../LanguageSwitcher/data'


import { useUrl } from '@/hooks/routes';
import { useState } from 'react';
import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
interface ILanguageTabProps {
  title: string
  className?: string
  icon?: string
}

export const LanguageTab: React.FC<ILanguageTabProps> = ({
  title,
  className,
  icon,
}) => {
  const currentUrl = useUrl()
  const [isOpen, setIsOpen] = useState(false)
  const localesList = ALL_LANGUAGES.filter((item) => item.locale)

  // 基础样式，不包含 hover 选中效果
  const baseItemCls =
    'text-f-text flex items-center gap-x-2 space-x-[2px] rounded px-2 py-2.5 text-base font-semibold md:py-1.5 md:text-sm'
  const itemCls = cls`
    hover:text-f-primary hover:bg-f-bg-hover text-f-text flex items-center
    space-x-[2px] rounded py-2.5 text-base font-semibold transition-all hover:cursor-pointer md:py-1.5 md:text-sm
  `

  return (
    <>
      {/* PC端实现 - 悬浮弹框 (md:flex) */}
      <div className={cls`${className} ${itemCls} group z-10 md:flex`}>
        <div className='peer flex items-center justify-between gap-1 px-2'>
          {icon && <span className={cls`${icon} block size-4`} />}
          <span>{title}</span>
          <span className='ltr:i-com--right rtl:i-com--left block size-4' />
        </div>
        <ul
          className={cls`
            border-f-border bg-f-bg-base absolute left-0 start-2 top-0
            grid -translate-x-full scale-0 grid-cols-[max-content_max-content] gap-x-6 gap-y-3 rounded-lg border p-4 opacity-0
            transition-all duration-300 hover:scale-100 hover:opacity-100 group-hover:scale-100 group-hover:opacity-100 ltr:origin-top-right ltr:-translate-x-full
            rtl:origin-top-left rtl:translate-x-full
          `}
        >
          {localesList.map((e) => {
            const url = new URL(currentUrl)

            url.pathname = `${e.abbr === 'en' ? '' : `/${e.abbr}`}${
              url.pathname === '/' && e.abbr !== 'en' ? '' : url.pathname
            }`
            return (
              <li key={e.abbr}>
                <Link
                  locale={e.abbr}
                  className='text-f-text-secondary hover:text-f-primary block size-full text-sm font-normal ltr:text-left rtl:text-right'
                  prefetch={false}
                  href={url.toString()}
                >
                  {e.language}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>

      {/* 移动端实现 - 展开列表 (md:hidden) */}
      <div
        className={`${baseItemCls} flex flex-col md:hidden ltr:items-start rtl:items-end`}
      >
        <div
          className='flex w-full cursor-pointer items-center justify-between gap-1'
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{title}</span>
          <span
            className={cls`i-com--down block size-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>
        {isOpen && (
          <div className='flex w-full flex-col pt-2.5'>
            {localesList.map((e) => {
              const url = new URL(currentUrl)

              url.pathname = `${e.abbr === 'en' ? '' : `/${e.abbr}`}${
                url.pathname === '/' && e.abbr !== 'en' ? '' : url.pathname
              }`
              return (
                <Link
                  key={e.abbr}
                  locale={e.abbr}
                  className='text-f-text-secondary hover:text-f-primary block py-2.5 text-base font-normal ltr:text-left rtl:text-right'
                  prefetch={false}
                  href={url.toString()}
                >
                  {e.language}
                </Link>
              )
            })}
          </div>
        )}
      </div>
    </>
  )
}
